































import { Component, Prop, Vue, Mixins, Ref } from "vue-property-decorator";
import VContentLoading from "@/components/VContentLoading.vue";
import VModal from "@/components/VModal.vue";
import VNumericInput from "@/components/VNumericInput.vue";
import BlueprintsMixin from "@/mixins/http/BlueprintsMixin";
import FileUploader from "@/components/FileUploader.vue";
import { showToast } from "../../utils/Toast";
import VMultiTuple from "@/components/VMultiTuple.vue";
import VTuple from "@/components/VTuple.vue";
import BlueprintFields from "./Fields.vue";
import { Blueprint } from "@/models";
import { RegisterHttp } from "@/utils/Decorators";
import RequestData from "@/store/types/RequestData";

const updateTag = "update_blueprint";

@Component({
  components: {
    VModal,
    VMultiTuple,
    VTuple,
    FileUploader,
    VNumericInput,
    BlueprintFields,
    VContentLoading,
  },
})
export default class BlueprintEditModal extends Mixins(BlueprintsMixin) {
  @Ref() readonly modal!: VModal;
  @RegisterHttp(updateTag) readonly http!: RequestData;

  item: Partial<Blueprint> | null = null;
  changeAttachment = false;

  canceled!: Function | null;

  mounted() {}

  get valid() {
    if (!this.item) {
      return false;
    }
    const baseValid = this.item.name;
    return baseValid;
  }

  title() {
    return `Edit Blueprint`;
  }

  onFileAdded(file) {
    this.changeAttachment = true;
    this.$nextTick(() => {
      if (!file.name.endsWith("obj")) {
        this.item.blueprint = null;
      } else {
        this.item.blueprint = file;
      }
    });
  }

  onDetachFile() {
    this.item.blueprint = null;
  }

  protected onCancel() {
    if (this.canceled) {
      this.canceled();
    }

    this.canceled = null;
    this.modal.hide();
  }

  protected async onConfirm() {
    const formData = new FormData();
    formData.append("name", this.item.name);
    formData.append("metadata", JSON.stringify(this.item.metadata));
    if (this.item.blueprint.file) {
      formData.append("blueprint", this.item.blueprint.file);
    }
    this.updateBlueprint(this.item.id, formData, updateTag).then(
      (resp) => {
        this.$emit("confirmed", resp);
        this.modal.hide();
        showToast(`Blueprint created successfully`);
      },
      (err) => {
        showToast(err?.response?.data?.message || err.message, {
          type: "error",
        });
      }
    );
  }

  protected onHidden() {
    if (this.canceled) {
      this.canceled();
    }
  }

  edit(item: Blueprint) {
    this.modal.show();

    if (!item.metadata.buswayDimensions) {
      item.metadata.buswayDimensions = { x: "100", y: "100", z: "100" };
    }
    if (!item.metadata.scale) {
      item.metadata.scale = { x: "1", y: "1", z: "1" };
    }
    if (!item.metadata.offset) {
      item.metadata.offset = { x: "0", y: "0", z: "0" };
    }
    this.item = { ...item };
  }
}
